<div class="container-fluid h-100 d-flex flex-column py-3 align-items-center">
  <div
    class="register card shadow p-4 overflow-auto overflow-x-hidden flex-grow-1 w-100"
  >
    <div class="mb-4 h5 fw-bold text-center">
      {{ 'app.register.register' | translate }}
    </div>
    <ul
      class="nav nav-justified"
      id="registerTab"
      (show.bs.tab)="onTabShow($event)"
    >
      <li
        id="tabPart1"
        class="nav-item btn btn-secondary rounded-0 py-1 me-1 active"
        data-bs-toggle="tab"
        data-bs-target="#registerPart1"
        data-rda-index="0"
        [class.btn-primary]="currentTabIndex >= 0"
      ></li>
      <li
        id="tabPart2"
        class="nav-item btn btn-secondary rounded-0 py-1 mx-1"
        data-bs-toggle="tab"
        data-bs-target="#registerPart2"
        data-rda-index="1"
        [class.btn-primary]="currentTabIndex >= 1"
      ></li>
      <li
        id="tabPart3"
        class="nav-item btn btn-secondary rounded-0 py-1 mx-1"
        data-bs-toggle="tab"
        data-bs-target="#registerPart3"
        data-rda-index="2"
        [class.btn-primary]="currentTabIndex >= 2"
      ></li>
      <li
        id="tabPart4"
        class="nav-item btn btn-secondary rounded-0 py-1 mx-1"
        data-bs-toggle="tab"
        data-bs-target="#registerPart4"
        data-rda-index="3"
        [class.btn-primary]="currentTabIndex >= 3"
      ></li>
      <li
        id="tabPart5"
        class="nav-item btn btn-secondary rounded-0 py-1 mx-1"
        data-bs-toggle="tab"
        data-bs-target="#registerPart5"
        data-rda-index="4"
        [class.btn-primary]="currentTabIndex >= 4"
      ></li>
      <li
        id="tabPart6"
        class="nav-item btn btn-secondary rounded-0 py-1 ms-1"
        data-bs-toggle="tab"
        data-bs-target="#registerPart6"
        data-rda-index="5"
        [class.btn-primary]="currentTabIndex >= 5"
      ></li>
    </ul>
    <div class="tab-content my-4">
      <div class="tab-pane active" id="registerPart1">
        <div class="mb-4">
          <div>{{ 'app.register.part' | translate }} 1</div>
          <div class="h5 fw-bold">
            {{ 'app.register.personalInformation' | translate }}
          </div>
        </div>
        <form [formGroup]="personalInfo" class="row row-cols-1 gy-3">
          <div class="col">
            <label class="form-label">
              <span class="text-danger">*</span>
              {{ 'app.register.email' | translate }}
            </label>
            <input
              formControlName="email"
              class="form-control"
              type="email"
              required
            />
            @let email = personalInfo.get('email');
            @if (email?.invalid && (email?.dirty || email?.touched)) {
              <div class="text-danger">
                @if (email?.hasError('required')) {
                  {{ 'app.register.pleaseEnter' | translate }}
                }
                @if (email?.hasError('email')) {
                  {{ 'app.login.emailValidate' | translate }}
                }
              </div>
            }
          </div>
          <div class="col">
            <label class="form-label">
              <span class="text-danger">*</span>
              {{ 'app.register.password' | translate }}
            </label>
            <input
              formControlName="password"
              class="form-control"
              [type]="personalInfo.controls.showPwd.value ? 'text' : 'password'"
              autocomplete="off"
            />
            @let pwd = personalInfo.get('password');
            @if (pwd?.invalid && (pwd?.dirty || pwd?.touched)) {
              <div class="text-danger">
                @if (pwd?.hasError('required')) {
                  {{ 'app.register.pleaseEnter' | translate }}
                }
                @if (pwd?.hasError('passwordPattern')) {
                  {{ 'validation.passwordPattern' | translate }}
                }
              </div>
            }
          </div>
          <div class="col form-check ms-3">
            <input
              formControlName="showPwd"
              class="form-check-input"
              type="checkbox"
              id="regPassword"
            />
            <label class="form-check-label" for="regPassword">
              {{ 'app.register.showPassword' | translate }}
            </label>
          </div>
          <div class="col">
            <label class="form-label" for="">
              <span class="text-danger">*</span>
              {{ 'app.register.confirmPassword' | translate }}
            </label>
            <input
              formControlName="confPassword"
              class="form-control"
              [type]="
                personalInfo.controls.showConfPwd.value ? 'text' : 'password'
              "
              autocomplete="off"
            />
            @let confPwd = personalInfo.get('confPassword');
            @if (confPwd?.dirty || confPwd?.touched) {
              <div class="text-danger">
                @if (confPwd?.hasError('required')) {
                  {{ 'app.register.pleaseEnter' | translate }}
                } @else if (personalInfo.hasError('passwordNotMatch')) {
                  {{ 'app.accountSetting.passwordNotMatch' | translate }}
                }
              </div>
            }
          </div>
          <div class="col form-check ms-3">
            <input
              formControlName="showConfPwd"
              class="form-check-input"
              type="checkbox"
              id="regConfPassword"
            />
            <label class="form-check-label" for="regConfPassword">
              {{ 'app.register.showPassword' | translate }}
            </label>
          </div>
          <div class="col">
            <label class="form-label">
              <span class="text-danger">*</span>
              {{ 'app.register.chineseName' | translate }}
            </label>
            <input formControlName="cnName" class="form-control" type="text" />
            @let cnName = personalInfo.get('cnName');
            @if (cnName?.invalid && (cnName?.dirty || cnName?.touched)) {
              <div class="text-danger">
                @if (cnName?.hasError('required')) {
                  {{ 'app.register.pleaseEnter' | translate }}
                }
              </div>
            }
          </div>
          <div class="col">
            <label class="form-label">
              <span class="text-danger">*</span>
              {{ 'app.register.englishName' | translate }}
            </label>
            <input formControlName="enName" class="form-control" type="text" />
            @let enName = personalInfo.get('enName');
            @if (enName?.invalid && (enName?.dirty || enName?.touched)) {
              <div class="text-danger">
                @if (enName?.hasError('required')) {
                  {{ 'app.register.pleaseEnter' | translate }}
                }
              </div>
            }
          </div>
          <div class="col">
            <label class="form-label">
              <span class="text-danger">*</span>
              {{ 'app.register.dateOfBirth' | translate }}
            </label>
            <input formControlName="birth" class="form-control" type="date" (change)="personalInfo.get('birth')?.updateValueAndValidity()" />
            @let birth = personalInfo.get('birth');
            @if (birth?.invalid && (birth?.dirty || birth?.touched)) {
              <div class="text-danger">
                @if (birth?.hasError('required')) {
                  {{ 'app.register.pleaseEnter' | translate }}
                } @else if (birth?.hasError('minAge')) {
                  {{ 'app.register.underAge' | translate }}
                }
              </div>
            }
          </div>
          <div class="col">
            <label class="form-label">
              <span class="text-danger">*</span>
              {{ 'app.register.idCardNo' | translate }}
            </label>
            <input
              formControlName="idCardNumber"
              class="form-control"
              type="text"
            />
            @let idCardNumber = personalInfo.get('idCardNumber');
            @if (
              idCardNumber?.invalid &&
              (idCardNumber?.dirty || idCardNumber?.touched)
            ) {
              <div class="text-danger">
                @if (idCardNumber?.hasError('required')) {
                  {{ 'app.register.pleaseEnter' | translate }}
                }
              </div>
            }
          </div>
          <div class="col">
            <div class="mb-2">
              <span class="text-danger">*</span>
              {{ 'app.register.gender' | translate }}
            </div>
            <div class="row row-cols-2 gx-2">
              <div class="col">
                <input
                  formControlName="gender"
                  class="btn-check"
                  type="hidden"
                  value=""
                />
                <input
                  formControlName="gender"
                  class="btn-check"
                  type="radio"
                  id="regGenderMaleRadio"
                  value="male"
                />
                <label
                  for="regGenderMaleRadio"
                  class="btn btn-outline-primary w-100"
                  >{{ 'app.register.male' | translate }}</label
                >
              </div>
              <div class="col">
                <input
                  formControlName="gender"
                  class="btn-check"
                  type="radio"
                  id="regGenderFemaleRadio"
                  value="female"
                />
                <label
                  for="regGenderFemaleRadio"
                  class="btn btn-outline-primary w-100"
                  >{{ 'app.register.female' | translate }}</label
                >
              </div>
            </div>
            @let gender = personalInfo.get('gender');
            @if (gender?.invalid && (gender?.dirty || gender?.touched)) {
              <div class="text-danger">
                @if (gender?.hasError('required')) {
                  {{ 'app.register.pleaseEnter' | translate }}
                }
              </div>
            }
          </div>
          <div class="col">
            <label class="form-label">
              <span class="text-danger">*</span>
              {{ 'app.register.occupation' | translate }}
            </label>
            <input
              formControlName="occupation"
              class="form-control"
              type="text"
            />
            @let occupation = personalInfo.get('occupation');
            @if (
              occupation?.invalid && (occupation?.dirty || occupation?.touched)
            ) {
              <div class="text-danger">
                @if (occupation?.hasError('required')) {
                  {{ 'app.register.pleaseEnter' | translate }}
                }
              </div>
            }
          </div>
          <div class="col">
            <label class="form-label">
              <span class="text-danger">*</span>
              {{ 'app.register.address' | translate }}
            </label>
            <input formControlName="address" class="form-control" type="text" />
            @let address = personalInfo.get('address');
            @if (address?.invalid && (address?.dirty || address?.touched)) {
              <div class="text-danger">
                @if (address?.hasError('required')) {
                  {{ 'app.register.pleaseEnter' | translate }}
                }
              </div>
            }
          </div>
          <div class="col">
            <label class="form-label">
              <span class="text-danger">*</span>
              {{ 'app.register.phoneNumber' | translate }}
            </label>
            <div class="input-group">
              <input formControlName="phoneCode" class="form-control" style="max-width: 85px;" type="text" />
              <input formControlName="phone" class="form-control" type="tel" />
            </div>
            @let phone = personalInfo.get('phone');
            @if (phone?.invalid && (phone?.dirty || phone?.touched)) {
              <div class="text-danger">
                @if (phone?.hasError('required')) {
                  {{ 'app.register.pleaseEnter' | translate }}
                }
                @if (phone?.hasError('pattern')) {
                  {{ 'validation.phoneMinDigits' | translate }}
                }
              </div>
            }
          </div>
        </form>
      </div>
      <div class="tab-pane" id="registerPart2">
        <div class="mb-4">
          <div>{{ 'app.register.part' | translate }} 2</div>
          <div class="h5 fw-bold">
            {{ 'app.register.emergencyContact' | translate }}
          </div>
        </div>
        <form [formGroup]="emergencyContact" class="row row-cols-1 gy-3">
          <div class="col">
            <label class="form-label">
              <span class="text-danger">*</span>
              {{ 'app.register.fullName' | translate }}
            </label>
            <input formControlName="name" class="form-control" type="text" />
            @let name = emergencyContact.get('name');
            @if (name?.invalid && (name?.dirty || name?.touched)) {
              <div class="text-danger">
                @if (name?.hasError('required')) {
                  {{ 'app.register.pleaseEnter' | translate }}
                }
              </div>
            }
          </div>
          <div class="col">
            <label class="form-label">
              <span class="text-danger">*</span>
              {{ 'app.register.relationship' | translate }}
            </label>
            <input
              formControlName="relationship"
              class="form-control"
              type="text"
            />
            @let relationship = emergencyContact.get('relationship');
            @if (
              relationship?.invalid &&
              (relationship?.dirty || relationship?.touched)
            ) {
              <div class="text-danger">
                @if (relationship?.hasError('required')) {
                  {{ 'app.register.pleaseEnter' | translate }}
                }
              </div>
            }
          </div>
          <div class="col">
            <label class="form-label">
              <span class="text-danger">*</span>
              {{ 'app.register.phoneNumber' | translate }}
            </label>
            <div class="input-group">
              <input formControlName="phoneCode" class="form-control" style="max-width: 85px;" type="text" />
              <input formControlName="phone" class="form-control" type="tel" />
            </div>
            @let relPhone = emergencyContact.get('phone');
            @if (relPhone?.invalid && (relPhone?.dirty || relPhone?.touched)) {
              <div class="text-danger">
                @if (relPhone?.hasError('required')) {
                  {{ 'app.register.pleaseEnter' | translate }}
                }
                @if (relPhone?.hasError('pattern')) {
                  {{ 'validation.phoneMinDigits' | translate }}
                }
              </div>
            }
          </div>
        </form>
      </div>
      <div class="tab-pane" id="registerPart3">
        <div class="mb-4">
          <div>{{ 'app.register.part' | translate }} 3</div>
          <div class="h5 fw-bold">
            {{ 'app.register.locationPreference' | translate }}
          </div>
        </div>
        <div class="h5 mb-4">
          {{ 'app.register.locationPreferenceTip' | translate }}
        </div>
        @let ids = locPreference.get('ids');
        @if (ids?.invalid && (ids?.dirty || ids?.touched)) {
          <div class="text-danger">
            @if (ids?.hasError('requiredTrue')) {
              {{ 'app.register.pleaseSelect' | translate }}
            }
          </div>
        }
        <form [formGroup]="locPreference" class="row row-cols-1 gy-3">
          @for (loc of locationPreferences; track $index) {
            <div class="col">
              <input
                formControlName="ids"
                id="preferredLoc{{ $index }}"
                type="checkbox"
                class="btn-check"
                (change)="pickLocPreference($event, loc.id)"
              />
              <label
                for="preferredLoc{{ $index }}"
                class="w-100 label-check border border-2 border-secondary rounded-2 p-2 text-secondary"
              >
                <div class="d-flex justify-content-between align-items-center">
                  @let isLocChecked = locPrefIds.has(loc.id);
                  <div
                    class="overflow-auto fw-bold"
                    [class.text-body]="!isLocChecked"
                    [class.text-secondary-purple]="isLocChecked"
                  >
                    {{ loc.name | translate }}
                  </div>
                  <div class="px-1">
                    <span
                      class="far fs-1 text-secondary"
                      [class.fa-circle]="!isLocChecked"
                      [class.fa-circle-check]="isLocChecked"
                    ></span>
                  </div>
                </div>
                <div class="border-top border-secondary my-2"></div>
                <div class="d-flex mb-2">
                  <div class="me-2">
                    <span
                      class="fas fa-location-dot"
                      style="padding: 0 2px"
                    ></span>
                  </div>
                  <div class="text-body overflow-auto">
                    {{ loc.address | translate }}
                  </div>
                </div>
                <div class="d-flex mb-2">
                  <div class="me-2">
                    <span class="fas fa-phone"></span>
                  </div>
                  <div class="text-body">{{ loc.phone }}</div>
                </div>
                <div
                  class="text-start text-body"
                  data-bs-toggle="collapse"
                  attr.data-bs-target="#dateAndTimeContent{{ $index }}"
                  (click)="preventDefault($event)"
                >
                  {{ 'app.register.seeTheDateTime' | translate }}
                  <span class="fas fa-angle-down ms-2"></span>
                </div>
                <div
                  class="collapse text-body"
                  id="dateAndTimeContent{{ $index }}"
                >
                  <div class="row row-cols-2">
                    @for (slot of loc.timeSlots; track $index) {
                      <div class="col">
                        <div>{{ slot.day | translate }}</div>
                        <div>{{ timeText(slot.time) }}</div>
                      </div>
                    }
                  </div>
                </div>
              </label>
            </div>
          }
        </form>
      </div>
      <div class="tab-pane" id="registerPart4">
        <div class="mb-4">
          <div>{{ 'app.register.part' | translate }} 4</div>
          <div class="h5 fw-bold">
            {{ 'app.register.knowledgeExperience' | translate }}
          </div>
        </div>
        <div class="h5 mb-4">
          {{ 'app.register.knowledgeExperienceTip' | translate }}
        </div>
        <form [formGroup]="knowAndExp" class="row row-cols-1 gy-3">
          <div class="col">
            <div class="mb-2">
              <span class="text-danger">*</span>
              {{ 'app.register.expRFD' | translate }}
            </div>
            <div class="btn-group w-100">
              <input
                formControlName="expRfdRadio"
                type="radio"
                class="btn-check"
                id="expRfdYes"
                value="yes"
              />
              <label class="btn btn-outline-primary" for="expRfdYes">{{
                'app.register.yes' | translate
              }}</label>
              <input
                formControlName="expRfdRadio"
                type="radio"
                class="btn-check"
                id="expRfdNo"
                value="no"
              />
              <label class="btn btn-outline-primary" for="expRfdNo">{{
                'app.register.no' | translate
              }}</label>
            </div>
            @let expRfdRadio = knowAndExp.get('expRfdRadio');
            @if (
              expRfdRadio?.invalid &&
              (expRfdRadio?.dirty || expRfdRadio?.touched) &&
              expRfdRadio?.hasError('required')
            ) {
              <div class="text-danger">
                {{ 'app.register.pleaseSelect' | translate }}
              </div>
            }
            @if (knowAndExp.controls.expRfdRadio.value === 'yes') {
              <div>
                <label for="expRefDetail" class="form-label"></label>
                <textarea
                  formControlName="expRfdRemark"
                  class="form-control"
                  id="expRefDetail"
                  rows="3"
                ></textarea>
              </div>
              @let expRfdRemark = knowAndExp.get('expRfdRemark');
              @if (
                knowAndExp.invalid &&
                (expRfdRemark?.dirty || expRfdRemark?.touched) &&
                knowAndExp.hasError('expRfdRemarkRequired')
              ) {
                <div class="text-danger">
                  {{ 'app.register.pleaseEnter' | translate }}
                </div>
              }
            }
          </div>
          <div class="col">
            <div class="mb-2">
              <span class="text-danger">*</span>
              {{ 'app.register.RHExp' | translate }}
            </div>
            <div class="btn-group w-100">
              <input
                formControlName="expRhRadio"
                type="radio"
                class="btn-check"
                id="expRhYes"
                value="yes"
              />
              <label class="btn btn-outline-primary" for="expRhYes">{{
                'app.register.yes' | translate
              }}</label>
              <input
                formControlName="expRhRadio"
                type="radio"
                class="btn-check"
                id="expRhNo"
                value="no"
              />
              <label class="btn btn-outline-primary" for="expRhNo">{{
                'app.register.no' | translate
              }}</label>
            </div>
            @let expRhRadio = knowAndExp.get('expRhRadio');
            @if (
              expRhRadio?.invalid &&
              (expRhRadio?.dirty || expRhRadio?.touched) &&
              expRhRadio?.hasError('required')
            ) {
              <div class="text-danger">
                {{ 'app.register.pleaseSelect' | translate }}
              </div>
            }
            @if (knowAndExp.controls.expRhRadio.value === 'yes') {
              <div>
                <label for="expRhDetail" class="form-label"></label>
                <textarea
                  formControlName="expRhRemark"
                  class="form-control"
                  id="expRhDetail"
                  rows="3"
                ></textarea>
              </div>
              @let expRhRemark = knowAndExp.get('expRhRemark');
              @if (
                knowAndExp.invalid &&
                (expRhRemark?.dirty || expRhRemark?.touched) &&
                knowAndExp.hasError('expRhRemarkRequired')
              ) {
                <div class="text-danger">
                  {{ 'app.register.pleaseEnter' | translate }}
                </div>
              }
            }
          </div>
          <div class="col">
            <div class="mb-2">
              <span class="text-danger">*</span>
              {{ 'app.register.medExp' | translate }}
            </div>
            <div class="btn-group w-100">
              <input
                formControlName="expMedRadio"
                type="radio"
                class="btn-check"
                id="expMedYes"
                value="yes"
              />
              <label class="btn btn-outline-primary" for="expMedYes">{{
                'app.register.yes' | translate
              }}</label>
              <input
                formControlName="expMedRadio"
                type="radio"
                class="btn-check"
                id="expMedNo"
                value="no"
              />
              <label class="btn btn-outline-primary" for="expMedNo">{{
                'app.register.no' | translate
              }}</label>
            </div>
            @let expMedRadio = knowAndExp.get('expMedRadio');
            @if (
              expMedRadio?.invalid &&
              (expMedRadio?.dirty || expMedRadio?.touched) &&
              expMedRadio?.hasError('required')
            ) {
              <div class="text-danger">
                {{ 'app.register.pleaseSelect' | translate }}
              </div>
            }
            @if (knowAndExp.controls.expMedRadio.value === 'yes') {
              <div>
                <label for="expMedDetail" class="form-label"></label>
                <textarea
                  formControlName="expMedRemark"
                  class="form-control"
                  id="expMedDetail"
                  rows="3"
                ></textarea>
              </div>
              @let expMedRemark = knowAndExp.get('expMedRemark');
              @if (
                knowAndExp.invalid &&
                (expMedRemark?.dirty || expMedRemark?.touched) &&
                knowAndExp.hasError('expMedRemarkRequired')
              ) {
                <div class="text-danger">
                  {{ 'app.register.pleaseEnter' | translate }}
                </div>
              }
            }
          </div>
          <div class="col">
            <div class="mb-2">
              <span class="text-danger">*</span>
              {{ 'app.register.knowAndExp.label' | translate }}
            </div>
            <div class="list-group">
              @for (opt of knowAndExpOptions; track $index) {
                <label class="list-group-item">
                  <input
                    formControlName="knowAndExpCheckBox"
                    class="form-check-input me-1"
                    type="checkbox"
                    (change)="pickKnowAndExp($event, opt.id)"
                  />
                  {{ opt.translate | translate }}
                </label>
              }
            </div>
            @let knowAndExpCheckBox = knowAndExp.get('knowAndExpCheckBox');
            @if (
              knowAndExpIds.size === 0 &&
              (knowAndExpCheckBox?.dirty || knowAndExpCheckBox?.touched)
            ) {
              <div class="text-danger">
                @if (knowAndExpCheckBox?.hasError('required')) {
                  {{ 'app.register.pleaseSelect' | translate }}
                }
              </div>
            }
          </div>
          <div class="col">
            <div class="mb-2">
              <span class="text-danger">*</span>
              {{ 'app.register.howDidFind.label' | translate }}
            </div>
            <div class="list-group">
              @for (opt of howFindOptions; track $index) {
                <label class="list-group-item">
                  <input
                    formControlName="howFindCheckBox"
                    class="form-check-input me-1"
                    type="checkbox"
                    (change)="pickHowDidFind($event, opt.id)"
                  />
                  {{ opt.translate | translate }}
                </label>
              }
              <label class="list-group-item">
                <input
                  formControlName="howFindOtherCheckBox"
                  class="form-check-input me-1"
                  type="checkbox"
                />
                {{ 'app.register.howDidFind.others' | translate }}
              </label>
            </div>
            @let howFindCheckBox = knowAndExp.get('howFindCheckBox');
            @let howFindOtherCheckBox = knowAndExp.get('howFindOtherCheckBox');
            @if (
              knowAndExp.invalid &&
              howDidFindIds.size === 0 &&
              (howFindCheckBox?.dirty ||
                howFindCheckBox?.touched ||
                howFindOtherCheckBox?.dirty ||
                howFindOtherCheckBox?.touched) &&
              knowAndExp.hasError('howFindRequired')
            ) {
              <div class="text-danger">
                {{ 'app.register.pleaseSelect' | translate }}
              </div>
            }
            @if (knowAndExp.controls.howFindOtherCheckBox.value) {
              <div>
                <label for="" class="form-label"></label>
                <textarea
                  formControlName="howFindRemark"
                  class="form-control"
                  rows="3"
                ></textarea>
              </div>
              @let howFindRemark = knowAndExp.get('howFindRemark');
              @if (
                knowAndExp.invalid &&
                (howFindRemark?.dirty || howFindRemark?.touched) &&
                knowAndExp.hasError('howFindRemarkRequired')
              ) {
                <div class="text-danger">
                  {{ 'app.register.pleaseEnter' | translate }}
                </div>
              }
            }
          </div>
        </form>
      </div>
      <div class="tab-pane" id="registerPart5">
        <div class="mb-4">
          <div>{{ 'app.register.part' | translate }} 5</div>
          <div class="h5 fw-bold">
            {{ 'app.register.volunteerReferralScheme' | translate }}
          </div>
        </div>
        <form [formGroup]="volReferral" class="row row-cols-1 gy-3">
          <div class="col">
            <label class="form-label" for="">{{
              'app.register.fullName' | translate
            }}</label>
            <input
              formControlName="fullName"
              class="form-control"
              type="text"
            />
          </div>
          <div class="col">
            <label class="form-label" for="">{{
              'app.register.contactNumber' | translate
            }}</label>
            <div class="input-group">
              <input formControlName="phoneCode" class="form-control" style="max-width: 85px;" type="text" />
              <input
                formControlName="contactNumber"
                class="form-control"
                type="tel"
              />
            </div>
            @let contactNum = volReferral.get('contactNumber');
            @if (contactNum?.invalid && (contactNum?.dirty || contactNum?.touched)) {
              <div class="text-danger">
                @if (contactNum?.hasError('pattern')) {
                  {{ 'validation.phoneMinDigits' | translate }}
                }
              </div>
            }
          </div>
          <div class="col">
            <label class="form-label" for="">{{
              'app.register.relWithReferer' | translate
            }}</label>
            <input
              formControlName="relationship"
              class="form-control"
              type="text"
            />
          </div>
        </form>
      </div>
      <div class="tab-pane" id="registerPart6">
        <div class="mb-4">
          <div>{{ 'app.register.part' | translate }} 6</div>
          <div class="h5 fw-bold">
            {{ 'app.register.declarationConsent' | translate }}
          </div>
        </div>
        <div class="h5 mb-4">
          {{ 'app.register.declarationTip' | translate }}
        </div>
        <div class="form-check mb-3">
          <input
            [formControl]="declAndCons.controls.declaration1"
            class="form-check-input"
            type="checkbox"
            id="declaration1"
          />
          <label class="form-check-label" for="declaration1">
            <span class="text-danger">*</span>
            {{ 'app.register.declaration1' | translate }}
          </label>
        </div>
        <div class="form-check mb-4">
          <input
            [formControl]="declAndCons.controls.declaration2"
            class="form-check-input"
            type="checkbox"
            id="declaration2"
          />
          <label class="form-check-label" for="declaration2">
            <span class="text-danger">*</span>
            {{ 'app.register.declaration2' | translate }}
          </label>
        </div>
        <div class="mb-4">
          <div class="h5 mb-2">
            <span class="text-danger">*</span>
            {{ 'app.register.photoConsent' | translate }}
          </div>
          <div class="form-check">
            <input
              [formControl]="declAndCons.controls.photoConsent"
              class="form-check-input"
              type="radio"
              id="photoConsentYes"
              value="agree"
            />
            <label class="form-check-label" for="photoConsentYes">
              {{ 'app.register.photoConsentYes' | translate }}
            </label>
          </div>
          <div class="form-check">
            <input
              [formControl]="declAndCons.controls.photoConsent"
              class="form-check-input"
              type="radio"
              id="photoConsentNo"
              value="disagree"
            />
            <label class="form-check-label" for="photoConsentNo">
              {{ 'app.register.photoConsentNo' | translate }}
            </label>
          </div>
        </div>
        <div class="h5 mb-4">
          {{ 'app.register.consentTip' | translate }}
        </div>
        <div class="form-check mb-4">
          <input
            [formControl]="declAndCons.controls.consentCVASP"
            class="form-check-input"
            type="checkbox"
            id="consentCVASP"
          />
          <label class="form-check-label" for="consentCVASP">
            <span class="text-danger">*</span>
            {{ 'app.register.iAgreeTo' | translate }}
            <a
              [href]="consentDocs.cvasp.url"
              target="_blank"
              class="link-underline-danger"
            >
              <span class="text-danger fw-bold">
                {{ 'consentCVASP' | translate }}
              </span>
            </a>
          </label>
        </div>
        <div class="form-check mb-4">
          <input
            [formControl]="declAndCons.controls.consentRaR"
            class="form-check-input"
            type="checkbox"
            id="consentRaR"
          />
          <label class="form-check-label" for="consentRaR">
            <span class="text-danger">*</span>
            {{ 'app.register.iAgreeTo' | translate }}
            <a
              [href]="consentDocs.rr.url"
              target="_blank"
              class="link-underline-danger"
            >
              <span class="text-danger fw-bold">{{
                'consentRaR' | translate
              }}</span>
            </a>
          </label>
        </div>
        <div class="form-check mb-4">
          <input
            [formControl]="declAndCons.controls.consentVWG"
            class="form-check-input"
            type="checkbox"
            id="consentVWG"
          />
          <label class="form-check-label" for="consentVWG">
            <span class="text-danger">*</span>
            {{ 'app.register.iAgreeTo' | translate }}
            <a
              [href]="consentDocs.vwg.url"
              target="_blank"
              class="link-underline-danger"
            >
              <span class="text-danger fw-bold">{{
                'consentVWG' | translate
              }}</span>
            </a>
          </label>
        </div>
        <div class="form-check mb-4">
          <input
            [formControl]="declAndCons.controls.consentIF2016"
            class="form-check-input"
            type="checkbox"
            id="consentIF2016"
          />
          <label class="form-check-label" for="consentIF2016">
            <span class="text-danger">*</span>
            {{ 'app.register.iAgreeTo' | translate }}
            <a
              [href]="consentDocs.if2016.url"
              target="_blank"
              class="link-underline-danger"
            >
              <span class="text-danger fw-bold">{{
                'consentIF2016' | translate
              }}</span>
            </a>
          </label>
        </div>
        <div class="form-check mb-4">
          <input
            [formControl]="declAndCons.controls.agreeToPrivacy"
            type="checkbox"
            class="form-check-input"
            id="agreePrivacy"
            (click)="onAgreePrivacyClick($event)"
          />
          <label class="form-check-label" for="agreePrivacy" (click)="onAgreePrivacyClick($event)">
            <span class="text-danger">*</span>
            {{ 'app.register.iAgreeTo' | translate }}
            <a href="javascript:void(0)" class="link-underline-danger" (click)="openTermsModal(); $event.preventDefault()">
              <span class="text-danger fw-bold">{{ 'app.login.tcAndPpLink' | translate }}</span>
            </a>
          </label>
          @let agreeCtrl = declAndCons.get('agreeToPrivacy');
          @if (agreeCtrl?.invalid) {
            <div class="text-danger small mt-1">
              {{ 'app.register.privacyRegisterRequired' | translate }}
            </div>
          }
        </div>
      </div>
    </div>
    <div
      class="btn-toolbar sticky-bottom justify-content-center py-2 column-gap-2"
    >
      @if (currentTabIndex > 0) {
        <div class="btn-group flex-fill">
          <button
            class="btn btn-outline-primary"
            [disabled]="currentTabIndex === 0 || isRegistering"
            (click)="prevPart()"
          >
            {{ 'app.register.back' | translate }}
          </button>
        </div>
      }
      @if (currentTabIndex === tabs.length - 1) {
        <div class="btn-group flex-fill">
          <button
            class="btn btn-primary"
            [disabled]="isRegistering || !isFormValid()"
            (click)="doRegister()"
          >
            {{ 'app.register.confirm' | translate }}
            @if (isRegistering) {
              <div class="spinner-border text-light spinner-border-sm"></div>
            }
          </button>
        </div>
      } @else {
        <div class="btn-group flex-fill">
          <button
            class="btn btn-primary"
            (click)="nextPart()"
            [disabled]="currentPartForm().invalid"
          >
            {{ 'app.register.next' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</div>

@if (showTermsModal) {
  <div class="privacy-overlay" (click)="declineTerms()">
    <div class="privacy-modal" (click)="$event.stopPropagation()">
      <div class="privacy-modal-header">
        <h5 class="mb-0">{{ siteTncTitle }}</h5>
        <button type="button" class="btn-close" (click)="declineTerms()"></button>
      </div>
      <div class="privacy-modal-body" #modalBody (scroll)="onModalScroll($event)">
        @if (loadingPdf) {
          <div class="text-center text-muted py-5">{{ 'app.login.loading' | translate }}</div>
        }
        <div class="pdf-pages" #termsContainer></div>
      </div>
      <div class="privacy-modal-footer">
        @if (!isScrolledToBottom) {
          <span class="scroll-hint">{{ 'app.login.scrollToAccept' | translate }}</span>
        }
        <!-- @if (isScrolledToBottom) {
          <span class="scroll-hint scroll-hint--done">{{ 'app.login.accept' | translate }} {{ 'app.login.privacyAnd' | translate }} {{ 'app.login.decline' | translate }}</span>
        } -->
        <button type="button" class="btn btn-outline-secondary btn-sm me-2" (click)="declineTerms()">
          {{ 'app.login.decline' | translate }}
        </button>
        <button type="button" class="btn btn-primary btn-sm" [disabled]="!isScrolledToBottom" (click)="acceptTerms()">
          {{ 'app.login.accept' | translate }}
        </button>
      </div>
    </div>
  </div>
}
